"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BannerAction = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../theme/utils/useTheme");
var _focusMode = require("../../focusMode");
var _BannerActionStyled = require("../styled/BannerActionStyled");
const BannerAction = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    clientId,
    isDisabled,
    onClick: providedOnClick,
    onDoubleClick: providedOnDoubleClick,
    ...rest
  } = _ref;
  const onClick = (0, _react.useCallback)(e => {
    if (isDisabled) {
      e.preventDefault();
      return;
    }
    if (providedOnClick) {
      providedOnClick(e);
    }
  }, [isDisabled, providedOnClick]);
  const onDoubleClick = (0, _react.useCallback)(e => {
    if (isDisabled) {
      e.preventDefault();
      return;
    }
    if (providedOnDoubleClick) {
      providedOnDoubleClick(e);
    }
  }, [isDisabled, providedOnDoubleClick]);
  const {
    focusMode
  } = (0, _focusMode.useFocusMode)();
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(_BannerActionStyled.BannerActionStyled, (0, _extends2.default)({
    focusMode: focusMode,
    tabIndex: 0,
    "aria-disabled": isDisabled,
    onClick: onClick,
    onDoubleClick: onDoubleClick,
    themeMode: themeMode,
    type: "button",
    "data-client-id": clientId
  }, rest, {
    ref: ref
  }), children);
});
exports.BannerAction = BannerAction;
BannerAction.displayName = "BannerAction";
//# sourceMappingURL=BannerAction.js.map